import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e96a0a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3e96a0a0&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=3e96a0a0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96a0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e96a0a0')) {
      api.createRecord('3e96a0a0', component.options)
    } else {
      api.reload('3e96a0a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e96a0a0&scoped=true", function () {
      api.rerender('3e96a0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/FriendshipLevel/index.vue"
export default component.exports